
import React from "react";
import autobind from "react-autobind";
import { actions } from "@gsd/redux-store-backoffice";
import { connect } from "react-redux";
import type { Dispatch } from "redux";

import Applications from "../component/Applications/Applications";

const {
  idmBackOffice: {
    creators: {
      getApplications,
      upsertApplication
    }
  }
} = actions;

const mapStateToProps = state => ({
  ...state.idmBackOffice
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getApplications: () => dispatch(getApplications()),
    upsertApplication: async (obj: unknown) => await dispatch(upsertApplication(obj)),
  };
};
type ApplicationContainerProps = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;
class ApplicationContainer extends React.Component<ApplicationContainerProps> {
  constructor(props: ApplicationContainerProps) {
    super(props);
    autobind(this);
  }

  async componentDidMount() {
    await this.props.getApplications();
  }

  async updateApplication(obj) {
    await this.props.upsertApplication(obj);
    await this.props.getApplications();
  }
  render() {
    const { applications } = this.props;
    return (
      <Applications
        dataElements={applications}
        upsertElement={this.updateApplication}
      />
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationContainer);
